import { DateTime, DateTimeService } from '@mews/framework';

export const isBirthdayBetweenDates = ({
    birthDate,
    startDate,
    endDate,
    timezone,
}: {
    birthDate: string;
    startDate: string;
    endDate: string;
    timezone: string;
}): boolean => {
    const start = DateTimeService.startOfDay(DateTimeService.fromUtcString(startDate, timezone));
    const end = DateTimeService.startOfDay(DateTimeService.fromUtcString(endDate, timezone));

    const startYear = DateTimeService.getYear(start);
    const endYear = DateTimeService.getYear(end);

    const birthDay = DateTimeService.fromUtcString(birthDate, timezone);
    const birthDayYear = DateTimeService.getYear(birthDay);

    const birthDayWithStartYear = DateTimeService.addYears(birthDay, startYear - birthDayYear);
    let birthDayWithCorrectYear: DateTime = birthDayWithStartYear;

    if (startYear !== endYear) {
        if (DateTimeService.isLess(birthDayWithStartYear, start)) {
            // If birthday with start year is before start date, then birthday year is set to the end year
            // for the correct comparison
            birthDayWithCorrectYear = DateTimeService.addYears(birthDay, endYear - birthDayYear);
        }
    }

    return (
        DateTimeService.isGreaterOrEqual(birthDayWithCorrectYear, start) &&
        DateTimeService.isLessOrEqual(birthDayWithCorrectYear, end)
    );
};
